module.exports = __webpack_public_path__ + "static/media/MAINTAIN 2.67ed4ce2.svg";